import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var PhoneOutgoing = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M13.707 11.707l5.172-5.172L21 8.656V3h-5.656l2.121 2.121-5.172 5.172zM7.3 16.408c4.006 4.006 9.023 4.299 10.406 4.299.201 0 .326-.006.357-.008a.994.994 0 0 0 .65-.291l1-1 .697-.697-5.414-5.414-.696.697-1.66 1.66c-.578-.109-1.734-.471-2.926-1.66-1.194-1.193-1.554-2.354-1.661-2.926l1.661-1.66.701-.701L5 3.293l-.7.701-1.001 1a.991.991 0 0 0-.291.649c-.014.25-.301 6.171 4.292 10.765z", key: "k0" })));
});
PhoneOutgoing.displayName = 'PhoneOutgoing';
export var PhoneOutgoingDimensions = { height: 24, width: 24 };
